import { render, staticRenderFns } from "./lessonBottom.vue?vue&type=template&id=f02fe8a6&scoped=true"
import script from "./lessonBottom.vue?vue&type=script&lang=js"
export * from "./lessonBottom.vue?vue&type=script&lang=js"
import style0 from "./lessonBottom.vue?vue&type=style&index=0&id=f02fe8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02fe8a6",
  null
  
)

export default component.exports